import React, { useCallback, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import CustomizerComponent from '@bit/gerenciatd.unifiedcomponents.customizer-component';
import { ConfiguratorCard } from './ConfiguratorCard';
import { NoSmartphoneAd } from './NoSmartphoneAd';
import { ConfiguratorContent } from './ConfiguratorContent';
import { useSelectedProductOfGroup } from '../../../hooks/useSelectedProductOfGroup';
import { actions as fusionActions } from '../../../reducers/fusion';
import { getDeviceInfoFromHiredProduct, getAditionalDeviceInfo } from './Utils';
import { USER_TYPE } from '../../../constants/constants';
import './Configurator.scss';

const COMPONENT_NAME = 'productmodal';
const mainSetup = require('../../../../config/mainSetup');

const CONFIGURATOR_CARD_NAME = 'product-configurable';
export const VARIANT = {
  HIRED: 'HIRED',
  RECOMMENDED: 'RECOMMENDED',
  VINTAGE: 'VINTAGE',
};

const Configurator = ({
  groupProducts,
  productHiredUnique,
  taggingInfo,
  variant,
}) => {
  const { hasClientAlreadyDevice, checkCanObtainSecondDevice } = useSelector(
    (state) => state.fusion
  );
  const { data: context } = useSelector((state) => state.context);
  const { userType } = context;

  const myHiredProducts = useSelector((state) => state.fusion.myHiredProduct);
  const deviceInfoIncluded = getDeviceInfoFromHiredProduct(myHiredProducts);
  const aditionalDevices = getAditionalDeviceInfo(myHiredProducts);

  const dispatch = useDispatch();

  const { selectedProduct } = useSelectedProductOfGroup(groupProducts);

  let enlaceToSecondTerminal = '';
  if (checkCanObtainSecondDevice) {
    enlaceToSecondTerminal = {
      text: 'Elige un dispositivo adicional desde 0€/mes',
      link:
        'https://www.movistar.es/mimovistar-cliente/publico/acceso/privado/cclivrmisproductos',
    };
  }

  const handleChangeRadioBtn = useCallback(
    (item) => {
      dispatch(fusionActions.setProductHiredSelected(item.product.alias));
    },
    [dispatch]
  );

  const configuratorCards = useMemo(() => {
    if (!selectedProduct) return null;
    const selectedProduc=selectedProduct.product.alias
    return Object.keys(groupProducts)
      .filter((key) => key.includes('fusion'))
      .map((key) => {
        const isSelected = groupProducts[key].product.alias === selectedProduct.product.alias;

        return (
          <ConfiguratorCard
            isHired={isSelected}
            isdefaultChecked={isSelected}
            name={CONFIGURATOR_CARD_NAME}
            product={isSelected ? selectedProduct : groupProducts[key]}
            productHiredUnique={productHiredUnique}
            handleChangeRadioBtn={handleChangeRadioBtn}
            taggingInfo={taggingInfo}
            selectedProduc={selectedProduc}

          />
        );
      });
  }, [groupProducts, handleChangeRadioBtn, productHiredUnique, selectedProduct, taggingInfo]);

  if (!selectedProduct) {
    return null;
  }

  return (
    <div className="configurator">
      {userType !== '' && userType !== USER_TYPE.GESTOR && !hasClientAlreadyDevice && (
        <CustomizerComponent
          spaId={mainSetup.projectId}
          componentName={COMPONENT_NAME}
          activityId="CMS-DISTRI-CONFIGURADOR-NO-TIENE-SMARTPHONE-AD"
          component={NoSmartphoneAd}
          customProps={{ taggingInfo }}
        />
      )}
      <div className="configurator__cards-wrapper">{configuratorCards}</div>
      {userType !== '' && userType !== USER_TYPE.GESTOR && !hasClientAlreadyDevice && (
        <CustomizerComponent
          spaId={mainSetup.projectId}
          componentName={COMPONENT_NAME}
          activityId="CMS-DISTRI-CONFIGURADOR-COMPRUEBA-SMARTPHONE"
          component={ConfiguratorContent}
          customProps={{ taggingInfo }}
        />
      )}
      {userType !== '' && userType !== USER_TYPE.GESTOR && hasClientAlreadyDevice && (
        <ConfiguratorContent
          title="DISPOSITIVO INCLUIDO"
          devicesInfo={deviceInfoIncluded}
          content="Cuando termine el periodo de renting podrás quedártelo en propiedad por 1€"
          enlace={enlaceToSecondTerminal}
          taggingInfo={taggingInfo}
        />
      )}
      { userType !== USER_TYPE.GESTOR && aditionalDevices
        && Array.isArray(aditionalDevices)
        && aditionalDevices.length > 0 && (
          <ConfiguratorContent
            title="DISPOSITIVO ADICIONAL"
            devicesInfo={aditionalDevices}
            content="Cuando termine el periodo de renting podrás quedártelo en propiedad por 1€"
          />
      )}

      {selectedProduct.product.containedChannels && userType !== USER_TYPE.GESTOR && (
        <CustomizerComponent
          spaId={mainSetup.projectId}
          componentName={COMPONENT_NAME}
          activityId="CMS-DISTRI-CONFIGURADOR-PAQUETES"
          component={ConfiguratorContent}
          customProps={{ taggingInfo }}
        />
      )}
      {
         userType !== USER_TYPE.GESTOR && (
         <CustomizerComponent
           spaId={mainSetup.projectId}
           componentName={COMPONENT_NAME}
           activityId="CMS-DISTRI-CONFIGURADOR-LINEAS"
           component={ConfiguratorContent}
           customProps={{ taggingInfo }}
         />
         )
      }

    </div>
  );
};

export default Configurator;
